"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Incinerator = void 0;
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var Tags_1 = require("../../Tags");
var CardRequirements_1 = require("../../CardRequirements");
var Incinerator = (function (_super) {
    __extends(Incinerator, _super);
    function Incinerator() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.INCINERATOR,
            cost: 8,
            tags: [Tags_1.Tags.BUILDING],
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oxygen(5); }),
            metadata: {
                cardNumber: 'L303',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action(undefined, function (eb) {
                        eb.plants(1).startAction.heat(6);
                    }).br;
                }),
                description: 'Spend 1 plant to gain 6 heat.',
            },
        }) || this;
    }
    Incinerator.prototype.play = function () {
        return undefined;
    };
    Incinerator.prototype.canAct = function (player) {
        return player.plants > 0;
    };
    Incinerator.prototype.action = function (player) {
        player.plants -= 1;
        player.heat += 6;
        return undefined;
    };
    return Incinerator;
}(Card_1.Card));
exports.Incinerator = Incinerator;
//# sourceMappingURL=Incinerator.js.map